// Formatação financeira centralizada do CRM FaroMarket.
//
// FaroMarket atende PMEs brasileiras: o locale de exibição é sempre pt-BR,
// independente da currency configurada. BRL é o default; USD/EUR/etc. são
// suportados quando o admin altera em /settings (e ainda assim renderizam
// com separador de milhar "." e decimal ",", padrão brasileiro).
//
// Antes desta helper, vários componentes (DealColumn, DealsPipeline, etc.)
// chamavam toLocaleString("en-US", { … currency }) hardcoded, causando
// "$1.5K" em vez de "R$ 1,5 mil" para a operação BR. Centralizar evita
// regressão futura.

const DISPLAY_LOCALE = "pt-BR";

type FormatOptions = Pick<
  Intl.NumberFormatOptions,
  | "notation"
  | "minimumFractionDigits"
  | "maximumFractionDigits"
  | "minimumSignificantDigits"
  | "maximumSignificantDigits"
  | "currencyDisplay"
>;

export const formatCurrency = (
  amount: number,
  currency: string,
  options: FormatOptions = {},
): string => {
  const safeCurrency =
    currency && typeof currency === "string" && currency.length === 3
      ? currency.toUpperCase()
      : "BRL";
  try {
    return new Intl.NumberFormat(DISPLAY_LOCALE, {
      style: "currency",
      currency: safeCurrency,
      currencyDisplay: options.currencyDisplay ?? "narrowSymbol",
      ...options,
    }).format(amount);
  } catch {
    // Fallback defensivo caso `currency` seja um código não suportado pelo runtime.
    return new Intl.NumberFormat(DISPLAY_LOCALE, {
      style: "currency",
      currency: "BRL",
      currencyDisplay: "narrowSymbol",
      ...options,
    }).format(amount);
  }
};

// Variante compacta para cards / colunas Kanban (ex: "R$ 1,5 mil").
export const formatCompactCurrency = (
  amount: number,
  currency: string,
): string =>
  formatCurrency(amount, currency, {
    notation: "compact",
    minimumSignificantDigits: 3,
  });
